import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchRefDataInterface } from '../interfaces/searchRefData.interface';
import { SearchRefDataItemModel } from './searchRefDataItem.model';

@JsonObject('SearchRefDataModel')
export class SearchRefDataModel implements SearchRefDataInterface {
  @JsonProperty('AssetClass', [SearchRefDataItemModel])
  AssetClass: SearchRefDataItemModel[];

  @JsonProperty('AssetType', [SearchRefDataItemModel])
  AssetType: SearchRefDataItemModel[];

  @JsonProperty('Currency', [SearchRefDataItemModel])
  Currency: SearchRefDataItemModel[];

  @JsonProperty('Management', [SearchRefDataItemModel])
  Management: SearchRefDataItemModel[];

  @JsonProperty('Market', [SearchRefDataItemModel])
  Market: SearchRefDataItemModel[];

  @JsonProperty('SRRI', [SearchRefDataItemModel])
  SRRI: SearchRefDataItemModel[];

  @JsonProperty('TER', [SearchRefDataItemModel])
  TER: SearchRefDataItemModel[];

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
